import React, { Component } from 'react'
import constructorio from 'utils/Constructorio.js';
import './GenrePage.scss'
import TextCTA from 'components/content/DiscoverForm/TextCTA'
import * as dumbleData from 'DumbleData';

export class GenrePage extends Component {
	componentDidMount() {
		let cachedFacets = this.props.cachedFacets;
		let currentFacets = this.getUserFacetSelections();
		if(Object.keys(this.props.values.genres).length === 0 || cachedFacets !== currentFacets) {
			this.fetchGenreFacets();
		}
		dumbleData.trackPageLoad()
		dumbleData.setTitle('BookWizard:Discover:Genre');
	}

	fetchGenreFacets = () => {
		let selectedGrades = this.props.getSelectedFacets('gradeLevels');
		let selectedCategories = this.props.getSelectedFacets('categories');
		let selectedSubjects = this.props.getSelectedFacets('subjects');

		constructorio.browse.getBrowseResults(
			'product-type',
			'books/individual-titles',
			{
				filters: {
					...(this.props.values.readingLevelSystem !== '') && {[this.props.values.readingLevelSystem]: this.props.values.readingLevelMin + "-" + this.props.values.readingLevelMax},
					'grade': selectedGrades,
					'super-genre': selectedCategories,
					'subject': selectedSubjects
				}
			}
		).then((data) => {
			let genres = data.response.facets.filter(facet => facet.name === 'genre');
			//Get 12 most popular genres by count
			let sortedGenres = genres[0].options.sort((a, b) => b.count - a.count).slice(0, 12);

			//Create state object from sortedGenres array
			let genreObj = {};
			sortedGenres.forEach(genre => genreObj[genre.value] = {'display_name': genre.display_name, 'selected': false});

			this.props.setDynamicFacets('genres', genreObj);
			this.props.handleChangeValue('cachedGenreFacets', this.getUserFacetSelections());
			
		}).catch((error) => {
			console.log(error);
		});
	}

	getUserFacetSelections = () => {
		const { values } = this.props;
		const excludedFacets = ['genres'];

		const filtered = Object.keys(values)
			.filter(key => !excludedFacets.includes(key))
			.reduce((obj, key) => {
				obj[key] = values[key];
				return obj;
			}, {});
		return JSON.stringify(filtered);
	}
	
	render() {
		const { values, handleChange } = this.props;
		let genreOptions = Object.entries(values.genres).map(([key, value]) => 
			<TextCTA 
				text={value.display_name}
				key={key}
				className="genrePage__cta"
				selected={value.selected}
				handleClick={() => handleChange('genres', key)}
			/>
		)

		return (
			<div className="genrePage">
				{genreOptions}
			</div>
		)
	}
}

export default GenrePage